import React, { Fragment, useState, useEffect, useContext, useRef } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import BookingTable from "./BookingTable";
import FilterTable from "../../Common/Component/FilterTable";
import SearchTable from "../../Common/Component/SearchTable";
import {
  bookingFilterColumns,
  searchColumns,
} from "../../../Data/Booking/BookingHistory";
import BookingContext from "../../../_helper/Booking";
import SharedDataContext from "../../../_helper/SharedData";
import {
  getBooking,
  getCancelReasons,
  getBookingCount,
  getBookingTableFilterData,
  getBookingTableSearchData,
  getBookingStatus,
  getBookingViaType,
} from "../../../Services/Booking.service";
import SelectedFilter from "./SelectedFilter";
import { showAlert, formatDateTime } from "../../../Services/Shared.service";
import moment from "moment";
import { useLocation } from "react-router";
import { CSVLink } from "react-csv";
import { Download } from "react-feather/dist";
const BookingHistory = () => {
  const location = useLocation();
  console.log("location", location)
  const { setOnSubmitData, emptyCallback } = useContext(BookingContext);
  const { globalCityField, setShowApiLoader, setPageNumber, dateFilter ,setDateFilter} =
    useContext(SharedDataContext);
  const localFromDate = moment(dateFilter.startDate).set({ h: 0, m: 0, s: 0, ms: 0 });
  const localToDate = moment(dateFilter.endDate).set({ h: 23, m: 59, s: 59, ms: 999 });
  const FormatFromDate = formatDateTime(
    localFromDate,
    "YYYY-MM-DD"
  );
  const FormatToDate = formatDateTime(localToDate, "YYYY-MM-DD");
  const firstUpdate = useRef(true);
  const [searchData, setSearchData] = useState(location.state?.searchdata ? location.state?.searchdata : "");
  const [loader, setLoader] = useState(false);

  const [filterType, setFilterType] = useState(location.state?.filterdata?.length > 0 ? "filter" : location.state?.searchdata ? "search" : "");
  const [vendorCancelledStatus, setVendorCancelledStatus] = useState(false);
  const [bookingData, setBookingData] = useState([]);

  const [paginationTotalRows, setPaginationTotalRows] = useState(0);

  const [reasonData, setReasonData] = useState([]);
  const [pagination, setPagination] = useState(
    location.state?.pageNumber ? location.state.pageNumber : 0
  );
  const [rowsPerPage, setRowsPerPage] = useState(20);
  let filterFromLocation = location.state?.filterdata?.length > 0 ? location.state?.filterdata.map((d)=>{
    if(d?.key == "Pickup"){
      return {
        ...d,
        key: <span>
        <Fragment>
          PICKUP <i className="fa fa-clock-o mr-2"></i>
        </Fragment>
      </span>
      }
    }else {
      return d
    }
  }) : []
  const [filterData, setFilterData] = useState(filterFromLocation);
  const [bookingStatusData, setBookingStatusData] = useState([]);
  const [bookingViaTypeData, setBookingViaTypeData] = useState([]);
  const [exportData, setExportData] = useState([]);

  let pickupTypeData = [
    {
      value: "AirportToCity",
      label: "AirportToCity",
    },
    {
      value: "CityToAirport",
      label: "CityToAirport",
    },
    {
      value: "CityToCity",
      label: "CityToCity",
    }
  ]

  let columns = [];
  const disableLoaders = () => {
    setLoader(false);
    // setShowApiLoader(false);
  };
  bookingFilterColumns.map((element) => {
    if (element.value) {
      columns.push({
        value: {
          name: element.name,
          value: element.value,
          type: element.type,
        },
        label: element.name,
      });
    }
  });

  const removeFilter = (index) => {
    let date = moment().format("YYYY-MM-DD");

    const filter = filterData[index];
    if (filter && filter.column_name === "pick_up_date_time") {
      localStorage.setItem('globalCityField', null);
      globalCityField.onChange(null);
      setDateFilter({
        startDate: date,
        endDate: date,
        label: "Today"
      })
    }
    const newfilterData = [...filterData];
    newfilterData.splice(index, 1);
    setFilterData(newfilterData);
  };
  console.log("filter data",filterData)

  console.log("location state", location?.state);
  const fetchBookingData = async ({ isSearchFilterPage }) => {
    const serviceCityId = globalCityField.value?.id?.toString() || null;
    const obj = {
      page: pagination,
      size: rowsPerPage,
      serviceCityId: serviceCityId ? serviceCityId : null,
      fromDate: FormatFromDate,
      toDate: FormatToDate,
    };
    if (filterData.length == 0 && !searchData) {
      setLoader(true);
      getBooking(obj)
        .then((result) => {
          setBookingData(result.data.list);
          setPaginationTotalRows(result.data.count);
          disableLoaders();
        })
        .catch((err) => {
          disableLoaders();
          setBookingData([]);
          showAlert("error", "Something went wrong");
        });

      // let pageObj = {
      //   serviceCityId: serviceCityId ? serviceCityId : null,
      //   fromDate: FormatFromDate,
      //   toDate: FormatToDate,
      // };
      // getBookingCount(pageObj).then((result) => {
      //   if (result.data) {
      //     setPaginationTotalRows(result.data);
      //   }
      // });
    } else if (filterData.length > 0 && filterType == "filter") {
      let body = [
        {
          service_city: serviceCityId
        }, {
          from: FormatFromDate,
          to: FormatToDate
        },
      ]
      filterData.forEach((element) => {
        body.push({
          column_name: element.column_name,
          value: element.values[0],
        });
      });
      setLoader(true);
      getBookingTableFilterData({ ...obj, page: isSearchFilterPage }, body)
        .then((result) => {
          if (result.data) {
            const data = result.data?.filterResponse || [];
            setBookingData(data);
            setPaginationTotalRows(result.data.count);
            disableLoaders();
          }
        })
        .catch((err) => {
          disableLoaders();
          setBookingData([]);
          showAlert("error", "Something went wrong");
        });
    } else if (searchData && filterType == "search") {
      let body = [
        {
          service_city: serviceCityId,
        },
        {
          from: FormatFromDate,
          to: FormatToDate
        },
        {
          column_names: searchColumns,
          value: searchData,
        },
      ];
      setLoader(true);
      getBookingTableSearchData(
        { ...obj, page: isSearchFilterPage },
        body
      )
        .then((result) => {
          if (result.data) {
            const data = result.data?.searchResponse || [];
            setBookingData(data);
            setPaginationTotalRows(result.data.count);
            disableLoaders();
          }
        })
        .catch((err) => {
          disableLoaders();
          setBookingData([]);
          showAlert("error", "Something went wrong");
        });
    }
  };
  useEffect(() => {
    setPageNumber(0);
    setOnSubmitData((prevData) => {
      return {
        ...prevData,
        fetchBookingData: () => {
          fetchBookingData({ isSearchFilterPage: pagination });
        },
      };
    });

    getCancelReasons().then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        const data = [];
        result.data.forEach((element) => {
          if (element.isDeleted) return;
          data.push({
            value: element,
            label: `${element.reason} - ${element.cancelType}`,
          });
        });
        setReasonData(data);
      }
    });

    getBookingStatus().then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        const data = [];
        result.data.forEach((element) => {
          data.push({
            value: element,
            label: element,
          });
        });
        setBookingStatusData(data);
      }
    });

    getBookingViaType().then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        const data = [];
        result.data.forEach((element) => {
          data.push({
            value: element,
            label: element,
          });
        });
        setBookingViaTypeData(data);
      }
    });

    return () => {
      setOnSubmitData((prevData) => {
        return { ...prevData, fetchBookingData: emptyCallback };
      });
    };
  }, []);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    fetchBookingData({ isSearchFilterPage: pagination });
  }, [dateFilter.startDate, dateFilter.endDate])

  const onChangePage = (page) => {
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    console.log("rows per page",currentRowsPerPage)
    setRowsPerPage(currentRowsPerPage);
  };

  useEffect(() => {
    if (filterData.length == 0 && filterType != "filter") return;
    setPagination(0)
    fetchBookingData({ isSearchFilterPage: 0 });
  }, [filterData]);

  useEffect(() => {
    if (!searchData && filterType != "search") return;
    setPagination(0)
    fetchBookingData({ isSearchFilterPage: 0 });
  }, [searchData]);

  useEffect(() => {
    console.log(filterData, "filterData");
    fetchBookingData({ isSearchFilterPage: pagination });
    
  }, [pagination, rowsPerPage, globalCityField.value]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  useEffect(() => {
    if (bookingData.length > 0) {
      let eData = bookingData.map((d) => {
        return {
          "BOOKING #": d.megaCabsBookingNo,
          "PICKUP TIME": new Date(d.pickUpDateTime),
          "CUSTOMER NAME": d.custName,
          "PHONE": d.custMobile,
          "PICKUP": d.pickUpAddress,
          "DROP": d.destAddress,
          "STATUS": d.currentBookingStatusType,
          "BOOKING VIA": d.bookingViaType,
          "PICKUP TYPE": d.pickupType,
          "CAR TYPE": d.carType,
          "MMT ID": d.mmtReferenceId,
        }
      })
      setExportData(eData)

    }
  }, [bookingData])

  return (
    <Fragment>
      <Breadcrumbs
        parent="Trip Management"
        subParent="All Bookings"
        mainTitle="All Bookings"
        exportBtn={
          <Btn attrBtn={{ style: { display: "flex", padding: "7px 14px 5px", justifyContent: "center", alignItems: "center" },title: "Export" }}>
            <CSVLink data={exportData} filename={"Booking_History"} style={{ color: "white" }}><Download size={"20px"}/></CSVLink>
          </Btn>
        }
        span1={
          <FilterTable
            options={columns}
            setFilterData={setFilterData}
            filterData={filterData}
            setSearchData={setSearchData}
            setFilterType={setFilterType}
            statusData={bookingStatusData}
            bookingViaTypeData={bookingViaTypeData}
            pickupTypeData={pickupTypeData}
          />
        }
        span3={
          <SearchTable
            searchData={searchData}
            setSearchData={setSearchData}
            setFilterData={setFilterData}
            setFilterType={setFilterType}
          />
        }
      />
      <Container fluid={true} className="datatables">
        <Row className="selected-filter">
          {filterData.map((element, i) => {
            return (
              <SelectedFilter
                key={i}
                element={element}
                index={i}
                removeFilter={removeFilter}
              />
            );
          })}
          {/* {filterData.length > 0 ? (
            <div className="save-filter">Save Filter</div>
          ) : (
            ""
          )} */}
        </Row>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="p-0">
                <BookingTable
                  reasonData={reasonData}
                  bookingData={bookingData}
                  onSubmitData={{
                    fetchBookingData: () =>
                      fetchBookingData({}),
                  }}
                  onChangePage={onChangePage}
                  paginationPerPage={rowsPerPage}
                  paginationTotalRows={paginationTotalRows}
                  onChangeRowsPerPage={onChangeRowsPerPage}
                  setShowApiLoader={setLoader}
                  pagination={pagination}
                  setPageNumber={setPageNumber}
                  pageNumber={
                    location.state?.pageNumber
                      ? location.state.pageNumber + 1
                      : 1
                  }
                  loader={loader}
                  filterData={filterData}
                  searchData={searchData}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default BookingHistory;
